import React from 'react';

const PergolasFeatures: React.FC = () => {
  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-primary mb-4">Why Choose Our Pergolas?</h2>
          <p className="text-xl text-gray-600">Built for Canadian Weather, Designed for Life</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="bg-white rounded-lg p-6 shadow-md">
              <div className="text-4xl mb-4">❄️</div>
              <h3 className="text-lg font-semibold text-primary mb-2">Winter-Ready Design</h3>
              <p className="text-gray-600">Engineered to handle Ontario snow loads and ice storms with confidence.</p>
            </div>
          </div>
          
          <div className="text-center">
            <div className="bg-white rounded-lg p-6 shadow-md">
              <div className="text-4xl mb-4">🔧</div>
              <h3 className="text-lg font-semibold text-primary mb-2">Professional Installation</h3>
              <p className="text-gray-600">Certified installers with electrical licensing and full insurance coverage.</p>
            </div>
          </div>
          
          <div className="text-center">
            <div className="bg-white rounded-lg p-6 shadow-md">
              <div className="text-4xl mb-4">⚡</div>
              <h3 className="text-lg font-semibold text-primary mb-2">Smart Technology</h3>
              <p className="text-gray-600">Motorized controls, LED lighting, and smart home integration available.</p>
            </div>
          </div>
          
          <div className="text-center">
            <div className="bg-white rounded-lg p-6 shadow-md">
              <div className="text-4xl mb-4">🛡️</div>
              <h3 className="text-lg font-semibold text-primary mb-2">Long-Term Warranty</h3>
              <p className="text-gray-600">5-10 year warranties with comprehensive coverage and local support.</p>
            </div>
          </div>
        </div>

        {/* Additional Features */}
        <div className="mt-16">
          <div className="bg-gradient-to-r from-accent to-green-700 rounded-xl p-8 text-white">
            <div className="grid md:grid-cols-3 gap-8 text-center">
              <div>
                <div className="text-3xl font-bold mb-2">47+</div>
                <p className="text-green-100">Happy Customers</p>
              </div>
              <div>
                <div className="text-3xl font-bold mb-2">5-10</div>
                <p className="text-green-100">Year Warranties</p>
              </div>
              <div>
                <div className="text-3xl font-bold mb-2">1-3</div>
                <p className="text-green-100">Day Installation</p>
              </div>
            </div>
          </div>
        </div>

        {/* Pergola Benefits */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-primary text-center mb-12">Pergola Benefits</h3>
          
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h4 className="text-xl font-semibold text-primary mb-4">Year-Round Enjoyment</h4>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start">
                  <span className="text-accent mr-3 mt-1">✓</span>
                  <span>Adjustable louvers for perfect shade control</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent mr-3 mt-1">✓</span>
                  <span>Weather protection from rain and UV rays</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent mr-3 mt-1">✓</span>
                  <span>Integrated heating and lighting options</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent mr-3 mt-1">✓</span>
                  <span>Extends outdoor living season</span>
                </li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-xl font-semibold text-primary mb-4">Smart Investment</h4>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start">
                  <span className="text-accent mr-3 mt-1">✓</span>
                  <span>Increases property value significantly</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent mr-3 mt-1">✓</span>
                  <span>Low maintenance aluminum construction</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent mr-3 mt-1">✓</span>
                  <span>Energy savings through shade provision</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent mr-3 mt-1">✓</span>
                  <span>Financing options available</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PergolasFeatures;
